var _path, _rect, _g, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpotIlustrations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 200,
    viewBox: "0 0 276 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 99.9991C0 57.9203 34.1116 23.8086 76.1905 23.8086H199.81C241.888 23.8086 276 57.9202 276 99.9991V123.809C276 165.887 241.888 199.999 199.81 199.999H76.1905C34.1116 199.999 0 165.887 0 123.809V99.9991Z",
    fill: "#FF5043"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1529_6277",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 276,
    height: 200
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 276,
    height: 200,
    rx: 76.1905,
    fill: "#FFB21D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1529_6277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8164 234.179L63.0047 212.378C51.7441 197.354 48.3056 154.057 47.9649 133.501L60.6282 106.152L86.3743 95.4496C100.106 92.9393 131.371 88.1565 146.581 89.1078C161.791 90.059 173.779 100.074 177.872 104.962C185.662 113.55 204.965 131.995 219.858 137.068C238.475 143.41 228.176 171.552 226.988 175.12C226.037 177.974 203.09 196.656 191.736 205.64L116.874 227.837L111.328 239.331L114.893 240.917C127.251 245.673 137.207 244.484 140.639 243.295L143.412 257.564C130.869 254.79 102.693 250.35 90.3353 254.79C77.9771 259.229 70.3985 272.23 68.154 278.175L65.3813 278.572C61.2883 273.683 52.5478 261.924 50.3297 253.997C48.1116 246.07 57.0633 237.482 61.8164 234.179Z",
    fill: "#FBF3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.977 100.204C148.878 97.0329 155.163 93.3334 158.067 91.8801C158.067 93.0692 161.084 94.7161 163.613 87.1237C170.742 65.7198 170.346 45.9014 166.781 36.3885L157.275 29.2539L126.776 40.3522L79.6406 96.2401C84.1297 102.582 93.8208 116.534 96.6727 121.608C99.5246 126.681 98.9172 141.162 98.2571 147.768L139.847 146.579L142.62 123.986L142.224 106.546C143.016 105.753 145.075 103.375 146.977 100.204Z",
    fill: "#E5A072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.238 107.099C139.455 108.545 135.039 109.231 129.946 105.756C131.927 107.209 134.462 110.829 128.758 113.683C121.628 117.251 104.2 116.458 114.895 90.2975C117.403 93.9969 123.054 101.713 125.589 102.981C121.892 100.207 114.102 90.3767 112.518 73.2536C110.934 56.1305 109.217 61.8911 108.557 66.9117L82.0098 99.6078C86.5351 106.072 93.1167 115.65 96.0155 120.481C107.148 117.79 121.964 115.001 128.758 116.458C137.308 118.291 139.031 136.616 134.653 146.73L139.849 146.582L142.621 123.989L142.238 107.099Z",
    fill: "#BE693B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.075 40.3534C154.503 34.6457 165.725 46.6953 169.158 53.4335C170.743 41.0669 167.178 35.0685 165.197 33.6151L151.334 26.4805C139.319 33.483 119.646 46.0611 137.075 40.3534Z",
    fill: "#BE693B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 4.21672,
    cy: 1.13356,
    rx: 4.21672,
    ry: 1.13356,
    transform: "matrix(0.932234 0.361856 -0.361422 0.932402 130.43 78.4609)",
    fill: "#FF5043"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 4.2164,
    cy: 1.13364,
    rx: 4.2164,
    ry: 1.13364,
    transform: "matrix(0.988734 0.149684 -0.149482 0.988764 155.238 84.3516)",
    fill: "#FF5043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.147 72.4609C149.883 74.4428 149.751 79.1199 151.335 81.9738C153.316 85.5411 154.9 90.694 144.602 88.3158",
    stroke: "#232323",
    strokeWidth: 1.99448,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.51 91.8828L136.278 92.0237C139.379 92.1816 142.419 92.945 145.226 94.271L148.561 95.8465",
    stroke: "#232323",
    strokeWidth: 1.99448,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.791 62.1946C133.204 62.9469 130.804 64.3351 129.404 65.5089C128.852 65.9718 129.294 66.6516 129.996 66.4924C135.571 65.2293 143.799 64.3821 148.36 64.0305C148.897 63.9891 149.241 63.4328 148.945 62.983C147.03 60.0666 142.887 60.9161 136.791 62.1946Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.745 53.144C123.28 48.7047 138.834 43.2348 149.264 41.253C184.517 48.3876 154.92 98.389 149.375 97.1999L158.374 99.5191C160.091 97.5373 163.841 92.4637 165.108 88.0244C166.692 82.4753 168.673 72.5661 169.861 56.315C171.049 40.0639 170.653 38.082 162.731 22.6237C156.394 10.257 146.36 8.48656 142.135 9.14718C132.232 3.99439 114.012 9.93992 102.129 36.4966C90.2461 63.0532 59.3506 99.5191 46.2795 127.265C39.8741 140.861 32.8592 178.739 52.211 183.835C51.1547 180.928 48.463 162.873 49.0967 149.555C49.8889 132.908 58.1623 113.788 66.0842 105.861C74.0061 97.9336 92.2265 104.672 100.544 98.33C108.862 91.9881 117.577 58.6932 120.745 53.144Z",
    fill: "#232323",
    stroke: "#232323",
    strokeWidth: 1.99448,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.996 64.7629C166.185 65.7836 167.496 66.6649 167.911 67.1758C168.06 67.3584 167.968 67.5922 167.789 67.7451L165.276 69.8937C164.972 70.153 164.518 70.1403 164.22 69.8748C156.532 63.024 156.559 66.2063 155.991 64.5682C155.523 63.218 157.934 63.143 162.996 64.7629Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.263,
    cy: 72.4595,
    rx: 4.75314,
    ry: 4.75642,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.661,
    cy: 73.6493,
    rx: 3.56485,
    ry: 3.56731,
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.861,
    cy: 74.8384,
    rx: 4.75314,
    ry: 4.75642,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.256,
    cy: 76.0283,
    rx: 3.56485,
    ry: 3.56731,
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.228 109.753C225.869 106.667 223.522 103.768 220.37 103.753L144.713 103.395C142.243 103.383 140.136 105.182 139.761 107.623L135.793 133.433C135.333 136.428 132.328 138.323 129.426 137.449L101.053 128.901C99.6694 128.484 98.1727 128.688 96.9509 129.46L82.2741 138.736C78.7969 140.934 79.3264 146.159 83.1737 147.615L105.068 155.898C106.79 156.549 108.013 158.097 108.249 159.923L116.43 223.282C116.766 225.884 119.061 227.78 121.679 227.62L195.597 223.115C196.092 223.085 196.581 222.981 197.045 222.806L225.401 212.165C227.556 211.357 228.878 209.177 228.599 206.892L219.974 136.35C219.908 135.81 219.931 135.263 220.042 134.731L225.228 109.753Z",
    fill: "#DE8845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.108 153.764C182.472 152.262 184.544 152.104 185.132 153.532L186.569 157.025C186.831 157.664 187.476 158.061 188.165 158.009L191.93 157.721C193.47 157.603 194.261 159.524 193.085 160.525L190.206 162.974C189.68 163.422 189.501 164.157 189.764 164.795L191.202 168.291C191.789 169.72 190.205 171.066 188.89 170.255L185.677 168.275C185.089 167.912 184.334 167.97 183.807 168.418L180.932 170.864C179.755 171.865 177.985 170.775 178.349 169.274L179.239 165.6C179.402 164.929 179.114 164.23 178.527 163.867L175.309 161.884C173.994 161.074 174.484 159.055 176.024 158.937L179.79 158.649C180.479 158.596 181.055 158.106 181.218 157.434L182.108 153.764Z",
    fill: "#DE8845"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.053 128.903C99.6694 128.486 98.1727 128.691 96.951 129.463L82.2741 138.739C78.7969 140.936 79.3264 146.162 83.1737 147.617L105.068 155.9C106.79 156.552 108.013 158.099 108.249 159.925L116.783 226.012C116.92 227.079 117.861 227.856 118.934 227.79C119.122 227.779 119.308 227.741 119.486 227.679L141.275 220.031C143.457 219.266 144.826 217.101 144.583 214.802L136.973 142.914C136.762 140.919 135.375 139.244 133.453 138.665L101.053 128.903Z",
    fill: "#FFB21D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.053 128.903C99.6694 128.486 98.1727 128.691 96.951 129.463L82.2741 138.739C78.7969 140.936 79.3264 146.162 83.1737 147.617L107.49 156.816C107.721 156.904 107.886 157.112 107.918 157.358C107.979 157.834 108.507 158.093 108.921 157.851L136.016 142.009C136.516 141.717 136.797 141.157 136.733 140.581C136.667 139.998 136.261 139.511 135.699 139.342L101.053 128.903Z",
    fill: "#DE8845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.403 128.984C190.067 120.259 164.793 138.504 177.259 120.832C207.156 78.4495 208.401 -31.8701 109.369 13.629",
    stroke: "#D9D9D9",
    strokeWidth: 1.99448,
    strokeLinecap: "round",
    strokeDasharray: "9.97 9.97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.228 109.754C225.869 106.668 223.521 103.769 220.37 103.754L144.713 103.395C142.243 103.384 140.136 105.182 139.761 107.624L135.012 138.514C134.964 138.827 134.651 139.024 134.348 138.933C133.939 138.81 133.564 139.206 133.71 139.607L134.317 141.283C134.529 141.869 135.1 142.246 135.722 142.213L136.795 142.156C136.799 142.156 136.804 142.156 136.809 142.158L136.843 142.168C136.849 142.17 136.855 142.166 136.856 142.161C136.856 142.156 136.86 142.153 136.865 142.152L218.243 137.814C219.269 137.759 220.035 136.846 219.91 135.826C219.886 135.634 219.895 135.439 219.934 135.25L225.228 109.754Z",
    fill: "#FFB21D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.756 137.086L229.721 210.009",
    stroke: "#232323",
    strokeWidth: 1.99448,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.173 92.2773C128.652 91.7841 131.287 90.4593 129.996 89.1064",
    stroke: "#232323",
    strokeWidth: 1.99448,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.913 72.0625C112.253 79.7256 114.894 97.3508 130.737 106.547",
    stroke: "#232323",
    strokeWidth: 1.99448,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2734 114.648L73.5723 146.009C74.6909 156.643 77.0725 167.107 80.6668 177.177L90.8273 205.647",
    stroke: "#232323",
    strokeWidth: 1.99448,
    strokeLinecap: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.809 75.9658L90.9365 75.8487",
    stroke: "white",
    strokeWidth: 1.90476,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.764 70.4323L93.6256 66.1445",
    stroke: "white",
    strokeWidth: 1.90476,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.33 64.8765L99.0137 56.2269",
    stroke: "white",
    strokeWidth: 1.90476,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5527 129.7C98.7361 128.703 102.405 127.186 107.611 129.102C112.818 131.017 129.109 137.482 136.604 140.475C136.801 129.102 138.497 105.996 143.704 104.559C148.911 103.123 189.658 103.562 209.38 103.961",
    stroke: "#232323",
    strokeWidth: 1.90476,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.3566,
    cy: 2.37955,
    rx: 5.3566,
    ry: 2.37955,
    transform: "matrix(-0.384833 -0.922986 0.922797 -0.385286 106.818 28.0742)",
    fill: "#D9D9D9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.3566,
    cy: 2.37955,
    rx: 5.3566,
    ry: 2.37955,
    transform: "matrix(-0.384833 -0.922986 0.922797 -0.385286 100.863 13.793)",
    fill: "#D9D9D9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.57106,
    cy: 5.354,
    rx: 3.57106,
    ry: 5.354,
    transform: "matrix(-0.384833 -0.922986 0.922797 -0.385286 99.8594 20.6602)",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotIlustrations);
export default __webpack_public_path__ + "static/media/Spot Ilustrations.9e125f4930eb5b22433bb3689e6c16a4.svg";
export { ForwardRef as ReactComponent };